export default import.meta.ROLLDOWN_FILE_URL_xVD0OkkwZ8C1QjBKZQaTkw